var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center py-5"},[_c('h4',{staticClass:"mb-2"},[_vm._v("Profile saved ✅")]),_c('p',{staticClass:"text-muted mb-4"},[_vm._v("You’re all set. You can close this tab.")])])
}]

export { render, staticRenderFns }